import React from 'react';
import PropTypes from 'prop-types';
import {Accordion, AccordionItem} from '@/components/molecules';
import GameDisplaySection from './GameDisplaySection';
import GameSettingsSection from './GameSettingsSection';
import GuidelineModal from './GuidelineModal';
import './WheelOfFortuneDisplayForm.scss';

const WheelOfFortuneDisplayForm = ({
  languages,
  activeTabIndex,
  setActiveTabIndex,
  currentLangData,
  updateField,
  handleImageUpload,
  handleImageDelete,
  handleImageFileError,
  imageUploadProgress,
  imageValidationError,
  showGuidelines,
  setShowGuidelines,
  slices,
  setSlices,
  equalProbability,
  setEqualProbability,
  equalPoints,
  setEqualPoints,
  sliceProbabilities,
  setSliceProbabilities,
  slicePoints,
  setSlicePoints,
  gameSettingsActiveTabIndex,
  setGameSettingsActiveTabIndex,
  gameSettingsCurrentLangData,
  updateGameSettingsField,
  totalProbability
}) => {
  return (
    <div
      className='wheel-of-fortune-display-form'
      data-testid='wheel-of-fortune-display-form'>
      <Accordion
        isDark
        size='large'
        content={
          <div className='w-full space-y-5'>
            <AccordionItem
              isDark
              expanded
              index={0}
              label='Game Display'
              onUpdate={() => {}}
              subTitle='How the game looks on PepsiConnect Games'
              content={
                <div className='w-full'>
                  <GameDisplaySection
                    languages={languages}
                    activeTabIndex={activeTabIndex}
                    setActiveTabIndex={setActiveTabIndex}
                    currentLangData={currentLangData}
                    updateField={updateField}
                    handleImageUpload={handleImageUpload}
                    handleImageDelete={handleImageDelete}
                    handleImageFileError={handleImageFileError}
                    imageUploadProgress={imageUploadProgress}
                    imageValidationError={imageValidationError}
                    setShowGuidelines={setShowGuidelines}
                  />
                </div>
              }
            />
            <AccordionItem
              key={`game-settings-${equalProbability}-${equalPoints}-${slices}`}
              isDark
              expanded
              index={1}
              label='Game Settings'
              onUpdate={() => {}}
              subTitle='Wheel displayed within the game'
              content={
                <div className='w-full'>
                  <GameSettingsSection
                    languages={languages}
                    gameSettingsActiveTabIndex={gameSettingsActiveTabIndex}
                    setGameSettingsActiveTabIndex={
                      setGameSettingsActiveTabIndex
                    }
                    gameSettingsCurrentLangData={gameSettingsCurrentLangData}
                    updateGameSettingsField={updateGameSettingsField}
                    slices={slices}
                    setSlices={setSlices}
                    equalProbability={equalProbability}
                    setEqualProbability={setEqualProbability}
                    equalPoints={equalPoints}
                    setEqualPoints={setEqualPoints}
                    sliceProbabilities={sliceProbabilities}
                    setSliceProbabilities={setSliceProbabilities}
                    slicePoints={slicePoints}
                    setSlicePoints={setSlicePoints}
                    totalProbability={totalProbability}
                    setShowGuidelines={setShowGuidelines}
                  />
                </div>
              }
            />{' '}
          </div>
        }
      />

      <GuidelineModal
        showGuidelines={showGuidelines}
        setShowGuidelines={setShowGuidelines}
      />
    </div>
  );
};

WheelOfFortuneDisplayForm.propTypes = {
  languages: PropTypes.array.isRequired,
  activeTabIndex: PropTypes.number.isRequired,
  setActiveTabIndex: PropTypes.func.isRequired,
  currentLangData: PropTypes.object.isRequired,
  updateField: PropTypes.func.isRequired,
  handleImageUpload: PropTypes.func.isRequired,
  handleImageDelete: PropTypes.func.isRequired,
  handleImageFileError: PropTypes.func,
  imageUploadProgress: PropTypes.number,
  imageValidationError: PropTypes.string,
  showGuidelines: PropTypes.bool.isRequired,
  setShowGuidelines: PropTypes.func.isRequired,
  slices: PropTypes.number.isRequired,
  setSlices: PropTypes.func.isRequired,
  equalProbability: PropTypes.bool.isRequired,
  setEqualProbability: PropTypes.func.isRequired,
  equalPoints: PropTypes.bool.isRequired,
  setEqualPoints: PropTypes.func.isRequired,
  sliceProbabilities: PropTypes.array.isRequired,
  setSliceProbabilities: PropTypes.func.isRequired,
  slicePoints: PropTypes.array.isRequired,
  setSlicePoints: PropTypes.func.isRequired,
  gameSettingsActiveTabIndex: PropTypes.number.isRequired,
  setGameSettingsActiveTabIndex: PropTypes.func.isRequired,
  gameSettingsCurrentLangData: PropTypes.object.isRequired,
  updateGameSettingsField: PropTypes.func.isRequired,
  totalProbability: PropTypes.number.isRequired
};

export default React.memo(WheelOfFortuneDisplayForm);
